module.exports = __webpack_public_path__ + "media/music/drumkit_2-719ff5a5.mp3";